import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { Swiper, SwiperSlide } from 'swiper/react';
import { setIsSubmit } from '../../saleJetBlockSlice';
import BtnPinkSmall from '../../../../Shared/Buttons/BtnPinkSmall';
import PopUp from '../../../../Shared/Popup/PopUp';
import PopOver from '../../../../Shared/Popover/Popover';
import { showAppLoader, hideAppLoader } from '../../../../Shared/Loader/LoaderSlice';

const Packages = (props) => {
    const [isPopOverOpen, setIsPopOverOpen] = useState(false);
    const [selected, setSelected] = useState(props.packageList.find(item => item.isSelected));

    useEffect(() => {
        if(selected){
            setIsPopOverOpen(true)
        }

        return () => {
        };
    }, []);
  
    return (
        <div className='sale-packages'>
                <div className='packages'>
                    <Swiper className="swiper-item"
                        spaceBetween={15}
                        slidesPerView='2'
                        scrollbar={{ draggable: true }}>
                        {props.packageList.map((item, i) => (
                            <SwiperSlide key={i}>
                                <div id={item.offreID}  className={`package ${item.isSelected ? 'selected' : ''}`} >
                                    <div className='header'>
                                        {item.header.text ? item.header.text : 
                                        item.header.isCounter ? 
                                        <>
                                        <div>המבצע הסתיים בעוד</div>
                                        </> : null
                                        }
                                    </div>
                                    <div className='content'>
                                        <div className='title'>{item.content.title}</div>
                                        <div className='price-wrapper'>
                                            {item.content.price.showStartFrom ? 'החל מ ' : null} <span className='price'>₪{item.content.price.price}</span>  {item.content.price.text}
                                            <div>
                                                {item.content.price.lineUnderPrice.isOldPrice ? 
                                                <span className='old-price'>₪{item.content.price.lineUnderPrice.price} </span> : 
                                                <span>₪{item.content.price.lineUnderPrice.price} </span>}
                                                {item.content.price.lineUnderPrice.text}
                                            </div>
                                        </div>
                                        <div className='free-text'>{item.content.price.freeText}</div>
                                    </div>


                                </div>
                          
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
                <PopOver
                      className='sale-package-popover'
                      placement='bottom'
                      text='בכל שלב, אפשר להקליק ולראות פה את פירוט ההזמנה'
                      target='fibber'
                      isOpen={isPopOverOpen}
                      closePopover={(e) => {setIsPopOverOpen(false)}}
                    />      
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
    };
};

const mapDispatchToProps = {
    setIsSubmit,
    showAppLoader,
    hideAppLoader
};

export default connect(mapStateToProps, mapDispatchToProps)(Packages);
